import React from 'react';
import MissionDashboard from '../domains/squads/components/MissionDashboard';

const MissionDashboardPage: React.FC = () => {
  return <MissionDashboard />;
};

export default MissionDashboardPage;

